// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"579":"f16bd579","897":"f16bd579"}[chunkId] + ".chunk.css";
};